module.exports = __webpack_public_path__ + "static/RST-PIO-CAN-BUN-64c116ff917c023eb287f3dbeee63976.jpg";